<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="commentsModal" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="notesModal">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="notesModalHeader">Comments</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <section v-if="!loading">
              <div v-if="data.status !== 'finished'" class="row">
                <div class="col-md-12">
                  <form @submit.prevent="addNewComment">
                    <div class="row">
                      <div class="col-md-12">
                        <label>Comment:</label>
                        <textarea class="form-control" rows="3" v-model="newComment"></textarea>
                      </div>
                    </div>
                    <div class="row mt-2">
                      <div class="col-md-12">
                        <label>Attachment:</label>
                        <input type="file" class="form-control" id="customFile" ref="file" @change="changeFile($event)">

                        <label class="mt-3">Paste Image here:</label>
                        <div class="image-div p-3" @paste="handlePaste" id="pasteTarget">
                          <span v-if="!file">
                            Paste image here.
                          </span>
                          <div class="w-150 preview text-center" v-else >
                            <img :src="url" alt=""><br>
                            <span class="btn btn-sm btn-danger my-1 ml-2 remove-image-btn" @click="removeImage">remove</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <button class="btn btn-sm btn-primary float-right" type="submit">Submit</button>
                  </form>
                </div>
              </div>
              <section v-if="data.comments && data.comments.length > 0">
                <hr v-if="data.status !== 'finished'">
                <h5>Added Comments</h5>
                <table class="table table-hover">
                  <thead>
                  <th>Comment</th>
                  <th>Attachment</th>
                  <th>Added By</th>
                  <th v-if="data.status !== 'finished'">Action</th>
                  </thead>
                  <tbody>
                  <tr v-for="(row, index) of data.comments" :key="index">
                    <td>
                      <span v-html="row.text"></span>
                    </td>
                    <td width="200px">
                      <a v-if="row.imageUrl" :href="row.imageUrl" target="_blank">
                        <img class="h-20" :src="row.imageUrl">
                      </a>
                    </td>
                    <td>
                      {{row.addedBy}}
                    </td>
                    <td  v-if="data.status !== 'finished'">
                      <button class="btn btn-sm btn-danger my-1" @click="deleteComment(index)"><i class="fa fa-trash"></i></button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </section>
              <section v-else-if="data.status === 'finished'">
                No comments available to show
              </section>
            </section>
            <div v-else class="loader"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {storage} from "@/firebase/init"
  export default {
    name: "checklistCommentsModal",
    data () {
      return {
        data: {},
        newComment: null,
        loading: false,
        file: null,
        event: null,
        url: null
      }
    },
    computed: {
      user() {
        return this.$store.getters.user;
      }
    },
    methods: {
        removeImage () {
            this.file = null
            this.url = null
            if (this.event) {
              this.event.target.value = ''
            }
        },
        handlePaste(e) {
          for (let i = 0 ; i < e.clipboardData.items.length ; i++) {
            let item = e.clipboardData.items[i];
            console.log(e);
            console.log(item);
            console.log(item.type);
          if (item.type.includes("image")) {
            // uploadFile(item.getAsFile());
            console.log(item.getAsFile())
            this.file = item.getAsFile()
            console.log(this.file)
            this.url = window.URL.createObjectURL(this.file)
          } else {
            console.log("Discarding image paste data");
          }
        }
      },
      changeFile (event) {
        this.file = event.target.files[0]
        this.url = window.URL.createObjectURL(this.file)
        this.event = event
      },
      load (obj) {
        this.data = obj
        $('#commentsModal').modal('show');
        $('.modal-backdrop').removeClass("modal-backdrop");
      },
      async addNewComment () {
        if (this.file || this.newComment) {
          this.loading = true
          let downloadURL = null
          if (this.file) {
            const storageRef = storage.ref();
            const timestamp = new Date().getTime().toString();
            const fileRef = storageRef.child('checklist-comments/' + this.file.name + timestamp );
            const uploadTask =  await fileRef.put(this.file)
            downloadURL = await uploadTask.ref.getDownloadURL()
          }
          if (this.newComment) {
            this.newComment = this.newComment.replace(/\n/g, '<br>')
          }
          const commentObject = {
            text: this.newComment,
            addedBy: this.user.firstName + ' ' + this.user.lastName,
            imageUrl: downloadURL
          }
          this.data.comments.push(commentObject)
          await this.updateComments()
          if (this.file) {
            if (this.event) {
              this.event.target.value = ''
            }
            this.file = null
            this.url = null
          }
          this.newComment = null
          this.loading = false

        }
      },
      async deleteComment (index) {
        this.loading = true
        this.data.comments.splice(index, 1)
        await this.updateComments()
        this.loading = false
      },
      async updateComments () {
        await this.$parent.updateChecklistComments(this.data)
      }
    }
  }
</script>

<style scoped lang="scss">
  .image-div {
    background-color: rgba(0,0,0, 0.1);
    border: 1px solid rgba(0,0,0, 0.3);
    width: 100%;
    height: 170px;
    .preview {
      img {
        height: 100px;
      }

    }
  }
  .w-150 {
    width: 150px;
  }
  .remove-image-btn {
    background-color: #ef8057;
    border: 1px solid rgba(0,0,0, 0.3);
  }
</style>
